var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 33.875C50.5638 33.875 51.1197 34.0065 51.6237 34.2589C51.6238 34.259 51.624 34.2591 51.6241 34.2591L89.1206 53.0074C89.1212 53.0077 89.1218 53.008 89.1224 53.0083C89.551 53.2192 89.9337 53.5128 90.2485 53.8722C90.5638 54.2321 90.8046 54.6508 90.9573 55.1042C91.1099 55.5576 91.1713 56.0367 91.1379 56.5139C91.1045 56.9912 90.9769 57.4571 90.7626 57.8848C90.5482 58.3125 90.2514 58.6935 89.8891 59.006C89.5268 59.3184 89.1062 59.556 88.6516 59.7051C88.1971 59.8543 87.7175 59.9119 87.2405 59.8748C86.7653 59.8378 86.302 59.7075 85.8773 59.4913L50.0001 42.0559L14.1276 59.4889C14.126 59.4897 14.1245 59.4905 14.123 59.4912C13.6982 59.7075 13.2349 59.8378 12.7597 59.8748C12.2827 59.9119 11.8031 59.8543 11.3485 59.7051C10.894 59.556 10.4734 59.3184 10.1111 59.006C9.74881 58.6935 9.45193 58.3125 9.2376 57.8848C9.02327 57.4571 8.89572 56.9912 8.8623 56.5139C8.82889 56.0367 8.89027 55.5576 9.0429 55.1042C9.19553 54.6508 9.43641 54.2321 9.75163 53.8722C10.0663 53.5129 10.4489 53.2194 10.8774 53.0084C10.8781 53.0081 10.8789 53.0078 10.8796 53.0074L48.3761 34.2591C48.3762 34.2591 48.3764 34.259 48.3765 34.2589C48.8805 34.0064 49.4364 33.875 50.0001 33.875Z",
    fill: "#DEE0E6",
    stroke: "#091E5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_140",
    x: -4,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_140",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTop);
export default __webpack_public_path__ + "static/media/scrollToTop.f3a91f8c86f139fc03d43152c8c8954c.svg";
export { ForwardRef as ReactComponent };